import * as React from "react";
import {InfoBanner} from "@ferry/portal-core";

interface INextYearAutoRenewalBannerProps {
    setPerformRenewal: (value: boolean) => void;
    turnOnNextYearRenewal: () => void;
}

interface INextYearAutoRenewalBannerState {
    displayInfoMessage: boolean;
}

export class NextYearAutoRenewalBanner extends React.Component<INextYearAutoRenewalBannerProps, INextYearAutoRenewalBannerState> {

    constructor(props: INextYearAutoRenewalBannerProps) {
        super(props);
    }

    public render() {
        return (
            <InfoBanner wording={
                <>
                    <strong>You have opted out of auto-renewal.</strong><br/>
                    Save time and stay covered next year. No strings.
                    <div>
                        <a onClick={() => this.props.turnOnNextYearRenewal()}
                           className="banner-link">
                            Opt in to auto-renew
                        </a>
                    </div>
                </>
            }/>
        )
    }
}
